import React, { useContext } from 'react'

import {
  TableBody as TableBodyMaterial,
  TableRow,
  TableCell,
  Typography,
} from '@material-ui/core'

import GenerateSkeleton from './../GenerateSkeleton'
import TableContext from 'contexts/TableContext'

const EmptyRow = () => {
  const { state } = useContext(TableContext)

  return state.emptyMessage ? (
    <TableRow>
      <TableCell colSpan={100}>
        <Typography variant="overline">{state.emptyMessage}</Typography>
      </TableCell>
    </TableRow>
  ) : null
}

const TableBody = ({ children, skeletonRows = 5, ...rest }) => {
  const { state } = useContext(TableContext)

  if (state.isLoading) {
    return (
      <TableBodyMaterial {...rest}>
        <GenerateSkeleton
          rows={skeletonRows}
          cols={state.cols}
          skeletonHeightArray={state.bodySkeletonHeightArray}
        />
      </TableBodyMaterial>
    )
  }

  return (
    <TableBodyMaterial {...rest}>
      {React.Children.count(children) ? children : <EmptyRow />}
    </TableBodyMaterial>
  )
}

export default TableBody
